import { SITE_PAGES } from 'Config';
import AccountLanding from 'Pages/Accounts/AccountLanding';
import ExpenseCodeDetails from 'Pages/Accounts/ExpenseCodes/ExpenseCodeDetails';
import PropTypes from 'prop-types';

const ExpenseCodeDetailsPage = ({
  expenseCodeId,
  expenseCodeObject,
  params,
}) => {
  let breadcrumbs = params?.id && [
    SITE_PAGES.EXPENSE_CODE,
    {
      icon: 'briefcase',
      text: params.id,
    },
  ];

  return (
    <AccountLanding title='Manage Expense Code' breadcrumbs={breadcrumbs}>
      <ExpenseCodeDetails
        expenseCodeId={params?.id || expenseCodeId}
        expenseCodeObject={expenseCodeObject}
      />
    </AccountLanding>
  );
};

ExpenseCodeDetailsPage.propTypes = {
  expenseCodeId: PropTypes.number,
  expenseCodeObject: PropTypes.object,
  params: PropTypes.shape({ id: PropTypes.string }),
};

export default ExpenseCodeDetailsPage;
